/**
 * User business related types
 */

import type { AccountType } from './session';

export interface OriginalUser {
  have_group_key: boolean;
  have_user_key: boolean;
  remark_first_name: string;
  remark_last_name: string;
  avatar: string;
  avatar_color: string;
  city: string;
  country: string;
  first_name: string;
  ip: string;
  last_name: string;
  province: string;
  register_time: number;
  user_id: string;
  username: string;
  username_a: string;
  state: StateEnum;
  is_risk: string;
  risk_end_time: number;
}

export enum StateEnum {
  NORMAL = 1,
  DELETE_ACCOUNT = 2,
  BAN = 3,
  LIMIT = 4,
}

export enum IsContactEnum {
  YES = 1,
  NO = 0,
}

export enum GenderEnum {
  MALE = '1',
  FEMALE = '2',
  OTHER = '__EMPTY__',
}

export interface User extends OriginalUser {
  name: string; // Primary name. first use remark name, if not set, use original name
  secondary_name?: string; // Secondary name. use original name if remark name is not set
  original_name: string; // Original name
  remark_name: string; // Remark name
  bio?: string;
  gender?: GenderEnum;
  birthday?: string;
  location?: string;
  hometown?: string;
  expire_duration?: string;
  call_in?: string;
  global_search?: string;
  account_type?: AccountType;
  background_url?: string;
  identifier_type?: 0 | 1;
}

export interface UserAddressResponseData {
  wallet_address: Record<string, string>;
}
